import { FlowDurationSchema } from 'flow-schema';
import pluralize from 'pluralize';

import { isDefined } from 'common';

export function describeJitter(value: unknown): string | undefined {
  // The field holds partial values like '' while the user is typing.
  const jitter = FlowDurationSchema.safeParse(value).data;
  if (!isDefined(jitter)) {
    return undefined;
  }
  const amount = `${jitter.value.toLocaleString()} ${pluralize(jitter.units, jitter.value)}`;
  return `Adds up to ${amount} randomly, so that flow runs don't overload your system by resuming at the same time.`;
}
